import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Container,
  Toolbar,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  IconButton,
  Divider,
  Avatar,
  Tooltip,
  Badge,
  Menu,
  MenuItem,
  InputBase,
  ListItemIcon,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import BusinessIcon from "@mui/icons-material/Business";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

import AddLeadDialog from "../../../Pages/Leads/AddLeadDialog";

import Logo from "../../../Assets/images/logo.svg";
import Styled from "styled-components";
import MenuList from "./MenuList"; // Import the MenuList component

const ImageWrap = Styled.div`
    .logo_image {
      width: auto;
      height: 45px;
      margin: 8px auto;
      display: block;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
    filter: ${props => props.isDarkTheme ? 'brightness(1.2)' : 'none'};
    }
    .logo_image:hover {
      transform: scale(1.05);
    filter: ${props => props.isDarkTheme ? 'brightness(1.5)' : 'brightness(1.1)'};
    }
  `;

const ResponsiveAppBar = ({ isDarkTheme }) => {
  const [openDialog, setOpenDialog] = useState(false); // To control logout confirmation dialog
  const [drawerOpen, setDrawerOpen] = useState(false); // To control the side menu
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isLoggingOut, setIsLoggingOut] = useState(false); // Loading state for logout process
  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);
  const [openAddLead, setOpenAddLead] = useState(false);
  const [searchValue, setSearchValue] = useState('');


  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down('lg'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // User information
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");

 
  // const ImageWrap = Styled.div`
  //   .logo_image {
  //     width: auto;
  //     height: 45px;
  //     margin: 8px auto;
  //     display: block;
  //     cursor: pointer;
  //     transition: all 0.3s ease-in-out;
  //     filter: ${isDarkTheme ? 'brightness(1.2)' : 'none'};
  //   }
  //   .logo_image:hover {
  //     transform: scale(1.05);
  //     filter: ${isDarkTheme ? 'brightness(1.5)' : 'brightness(1.1)'};
  //   }
  // `;

  const handleLogoClick = () => {
    const isLoggedIn = localStorage.getItem("isAuthenticated");
    
    if (isLoggedIn) {
      // Get menuList from localStorage
      const menuList = JSON.parse(localStorage.getItem("menuList") || "[]");
      
      // Find first permitted menu item (with permission: "yes")
      const defaultMenu = menuList.find(menu => menu.permission === "yes");
      
      if (defaultMenu) {
        // Map menuId to route path
        const menuToRoutePath = {
          'MENU-001': '/dashboard',
          'MENU-002': '/salesboard',
          'MENU-003': '/users'
        };
        
        // Navigate to the mapped route or fallback to dashboard
        const route = menuToRoutePath[defaultMenu.menuId] || '/dashboard';
        navigate(route);
      } else {
        // If no permitted menus, go to dashboard
        navigate("/dashboard");
      }
    } else {
      // If not logged in, go to login page
      navigate("/");
    }
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen); // Toggle the drawer open/close state
  };

  const handleMenuItemClick = (path) => {
    navigate(path); // Navigate to the selected menu item
    setDrawerOpen(false); // Close the drawer after navigation
  };

  const handleLogoutClick = () => {
    setOpenDialog(true);
  };

  const handleLogoutCancel = () => {
    setOpenDialog(false);
  };

  const isLoginPage = location.pathname === "/";

  // Update current time every second
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Format date in DD-MMM-YYYY format
  const formatDate = (date) => {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format time in HH:MM:SS AM/PM format
  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };



  return (

    <Box sx={{ position: "relative" }}>
      <AppBar
        className="customize_header"
        position="static"
        sx={{
          background: isDarkTheme
            ? "linear-gradient(120deg, #0f172a 0%, #1e293b 55%, #0b1220 100%)"
            : "linear-gradient(120deg, #ffffff 0%, #f7fbff 55%, #eef4fb 100%)",
          color: isDarkTheme ? "#fff" : "#000",
          fontFamily: "DM Sans",
          boxShadow: isDarkTheme
            ? "0 12px 28px rgba(2, 6, 23, 0.45)"
            : "0 10px 24px rgba(15, 23, 42, 0.12)",
          borderRadius: "0 0 14px 14px",
          borderBottom: isDarkTheme ? "1px solid rgba(148,163,184,0.2)" : "1px solid #e2e8f0",
        }}
      >
        <Container>
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between", // Space out elements
              alignItems: "center",
              flexWrap: "nowrap", // Prevent wrapping
              py: 0.5, // Add some vertical padding
            }}
          >
            {/* Left Section: Burger Menu and Logo */}
            <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              {/* Conditionally Render Burger Menu */}
              {!isLoginPage && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{
                    marginRight: "16px",
                    transition: "all 0.3s ease-in-out",
                    background: isDarkTheme 
                      ? "rgba(148,163,184,0.16)" 
                      : "rgba(15,23,42,0.05)",
                    "&:hover": {
                      transform: "scale(1.05)",
                      background: isDarkTheme 
                        ? "rgba(148,163,184,0.26)" 
                        : "rgba(15,23,42,0.1)",
                    },
                  }}
                >
                  <MenuIcon />
                </IconButton>
              )}

              {/* Logo */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  marginRight: "24px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={handleLogoClick}
              >
                <ImageWrap>
                  <img
                    className="logo_image"
                    src={Logo}
                    alt="Orucore"
                  />
                </ImageWrap>
                {/* <Box 
                  sx={{ 
                    display: "flex", 
                    flexDirection: "column", 
                    alignItems: "flex-start", 
                    ml: 1.5 
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "12px",
                      color: isDarkTheme ? "#fff" : "#000",
                      letterSpacing: "0.5px",
                      lineHeight: 1.2,
                    }}
                  >
                    Orucore
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "10px",
                      color: isDarkTheme ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.6)",
                      lineHeight: 1.2,
                    }}
                  >
                    AUJ Group
                  </Typography>
                </Box> */}

              </Box>
            </Box>

            {/* Right action bar */}
            {!isLoginPage && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 'auto', flexShrink: 0 }}>

                {/* Date + time compact */}
                {!isCompact && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mr: 0.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <CalendarTodayIcon sx={{ fontSize: 13, color: isDarkTheme ? '#90caf9' : '#3949ab' }} />
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: isDarkTheme ? '#cdd5f7' : '#3949ab' }}>
                      {formatDate(currentTime)}
                    </Typography>
                  </Box>
                  <Divider orientation="vertical" flexItem sx={{ height: 14, alignSelf: 'center', borderColor: isDarkTheme ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)' }} />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <AccessTimeIcon sx={{ fontSize: 13, color: isDarkTheme ? '#4caf50' : '#388e3c' }} />
                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: isDarkTheme ? '#4caf50' : '#388e3c' }}>
                      {formatTime(currentTime)}
                    </Typography>
                  </Box>
                </Box>}

                {!isCompact && <Divider orientation="vertical" flexItem sx={{ height: 22, alignSelf: 'center', mx: 0.25, borderColor: isDarkTheme ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }} />}

                {/* Search input */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75,
                    bgcolor: isDarkTheme ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.04)',
                    border: `1px solid ${isDarkTheme ? 'rgba(255,255,255,0.13)' : 'rgba(0,0,0,0.11)'}`,
                    borderRadius: '8px',
                    px: 1,
                    py: 0.35,
                    width: isTablet ? 140 : 205,
                    transition: 'border-color 0.2s, box-shadow 0.2s',
                    '&:focus-within': {
                      borderColor: isDarkTheme ? '#7986cb' : '#4B5AB6',
                      boxShadow: isDarkTheme ? '0 0 0 2px rgba(121,134,203,0.18)' : '0 0 0 2px rgba(75,90,182,0.13)',
                      bgcolor: isDarkTheme ? 'rgba(255,255,255,0.1)' : '#fff',
                    },
                  }}
                >
                  <SearchIcon sx={{ fontSize: 15, color: isDarkTheme ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.35)', flexShrink: 0 }} />
                  <InputBase
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                    placeholder="Search..."
                    sx={{
                      flex: 1,
                      fontSize: 13,
                      color: isDarkTheme ? '#fff' : '#111',
                      '& input': { p: 0, '&::placeholder': { color: isDarkTheme ? 'rgba(255,255,255,0.38)' : 'rgba(0,0,0,0.38)', opacity: 1 } },
                    }}
                  />
                  <Box
                    sx={{
                      fontSize: 10,
                      fontWeight: 600,
                      color: isDarkTheme ? 'rgba(255,255,255,0.28)' : 'rgba(0,0,0,0.28)',
                      bgcolor: isDarkTheme ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
                      border: `1px solid ${isDarkTheme ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.1)'}`,
                      borderRadius: '4px',
                      px: 0.6,
                      py: 0.1,
                      lineHeight: 1.6,
                      flexShrink: 0,
                      letterSpacing: 0,
                    }}
                  >
                    ⌘K
                  </Box>
                </Box>

                {/* Create */}
                <Button
                  size="small"
                  onClick={e => setCreateMenuAnchor(e.currentTarget)}
                  startIcon={<AddIcon sx={{ fontSize: '16px !important' }} />}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 700,
                    color: '#fff',
                    bgcolor: isDarkTheme ? '#2563eb' : '#1d4ed8',
                    borderRadius: '8px',
                    px: 1.25,
                    py: 0.4,
                    fontSize: 13,
                    boxShadow: '0 8px 18px rgba(29,78,216,0.28)',
                    '&:hover': { bgcolor: isDarkTheme ? '#1d4ed8' : '#1e40af' },
                  }}
                >
                  Create
                </Button>

                {/* Create dropdown */}
                <Menu
                  anchorEl={createMenuAnchor}
                  open={Boolean(createMenuAnchor)}
                  onClose={() => setCreateMenuAnchor(null)}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      borderRadius: 2,
                      boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                      minWidth: 200,
                      py: 0.5,
                    },
                  }}
                  transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                >
                  {[
                    { label: 'New Lead',        icon: <PersonAddAltIcon fontSize="small" />,      color: '#4B5AB6', action: () => { setCreateMenuAnchor(null); setOpenAddLead(true); } },
                    { label: 'New Contact',     icon: <ContactMailIcon fontSize="small" />,       color: '#0288d1', action: () => setCreateMenuAnchor(null) },
                    { label: 'New Company',     icon: <BusinessIcon fontSize="small" />,          color: '#388e3c', action: () => setCreateMenuAnchor(null) },
                    { label: 'New Opportunity', icon: <LightbulbOutlinedIcon fontSize="small" />, color: '#f57c00', action: () => setCreateMenuAnchor(null) },
                    { label: 'New Task',        icon: <TaskAltIcon fontSize="small" />,           color: '#7b1fa2', action: () => setCreateMenuAnchor(null) },
                    { label: 'New Meeting',     icon: <GroupsIcon fontSize="small" />,            color: '#c62828', action: () => setCreateMenuAnchor(null) },
                    { label: 'New Quote',       icon: <RequestQuoteIcon fontSize="small" />,      color: '#00796b', action: () => setCreateMenuAnchor(null) },
                  ].map(item => (
                    <MenuItem
                      key={item.label}
                      onClick={item.action}
                      sx={{ gap: 1, py: 0.9, '&:hover': { bgcolor: 'rgba(75,90,182,0.07)' } }}
                    >
                      <ListItemIcon sx={{ minWidth: 28, color: item.color }}>{item.icon}</ListItemIcon>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>{item.label}</Typography>
                    </MenuItem>
                  ))}
                </Menu>

                {!isCompact && <Divider orientation="vertical" flexItem sx={{ height: 22, alignSelf: 'center', mx: 0.25, borderColor: isDarkTheme ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }} />}

                {/* Calendar */}
                {!isCompact && <Tooltip title="Calendar">
                  <IconButton size="small" sx={{ color: isDarkTheme ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.55)', '&:hover': { bgcolor: isDarkTheme ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)' } }}>
                    <CalendarMonthIcon sx={{ fontSize: 19 }} />
                  </IconButton>
                </Tooltip>}

                {/* Chat */}
                {!isCompact && <Tooltip title="Messages">
                  <IconButton size="small" sx={{ color: isDarkTheme ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.55)', '&:hover': { bgcolor: isDarkTheme ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)' } }}>
                    <ChatBubbleOutlineIcon sx={{ fontSize: 19 }} />
                  </IconButton>
                </Tooltip>}

                {/* AI */}
                {!isCompact && <Tooltip title="AI Assistant">
                  <Button
                    size="small"
                    startIcon={<AutoAwesomeIcon sx={{ fontSize: '15px !important' }} />}
                    sx={{
                      textTransform: 'none',
                      fontWeight: 700,
                      color: isDarkTheme ? '#ce93d8' : '#7b1fa2',
                      bgcolor: isDarkTheme ? 'rgba(206,147,216,0.1)' : 'rgba(123,31,162,0.07)',
                      borderRadius: '8px',
                      px: 1,
                      py: 0.4,
                      fontSize: 13,
                      minWidth: 'auto',
                      '&:hover': { bgcolor: isDarkTheme ? 'rgba(206,147,216,0.2)' : 'rgba(123,31,162,0.13)' },
                    }}
                  >
                    AI
                  </Button>
                </Tooltip>}

                {/* Notifications */}
                <Tooltip title="Notifications">
                  <IconButton size="small" sx={{ color: isDarkTheme ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.55)', '&:hover': { bgcolor: isDarkTheme ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)' } }}>
                    <Badge badgeContent={0} color="error">
                      <NotificationsNoneIcon sx={{ fontSize: 20 }} />
                    </Badge>
                  </IconButton>
                </Tooltip>

                <Divider orientation="vertical" flexItem sx={{ height: 22, alignSelf: 'center', mx: 0.25, borderColor: isDarkTheme ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }} />

                {/* User menu */}
                <Button
                  onClick={e => setUserMenuAnchor(e.currentTarget)}
                  endIcon={<ArrowDropDownIcon />}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    color: isDarkTheme ? '#fff' : '#000',
                    borderRadius: '8px',
                    px: 0.75,
                    py: 0.4,
                    gap: 0.5,
                    '&:hover': { bgcolor: isDarkTheme ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.06)' },
                  }}
                >
                  <Avatar sx={{ width: 27, height: 27, fontSize: 12, fontWeight: 700, bgcolor: isDarkTheme ? '#3949ab' : '#4B5AB6' }}>
                    {userName?.charAt(0)?.toUpperCase() || 'U'}
                  </Avatar>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: isDarkTheme ? '#fff' : '#111' }}>
                    {userName?.split(' ')[0] || 'User'}
                  </Typography>
                </Button>

                <Menu
                  anchorEl={userMenuAnchor}
                  open={Boolean(userMenuAnchor)}
                  onClose={() => setUserMenuAnchor(null)}
                  PaperProps={{ sx: { mt: 1, borderRadius: 2, boxShadow: '0 8px 24px rgba(0,0,0,0.15)', minWidth: 150 } }}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
                  <MenuItem
                    onClick={() => { setUserMenuAnchor(null); handleLogoutClick(); }}
                    sx={{ gap: 1.5, color: '#d32f2f', py: 1 }}
                  >
                    <LogoutIcon fontSize="small" />
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>Logout</Typography>
                  </MenuItem>
                </Menu>
              </Box>
            )}

            {/* Conditionally render Login Button */}
            {isLoginPage && (
              <Box sx={{ flexGrow: 0 }}>
                <Button
                  variant="contained"
                  onClick={() => navigate("/login")}
                  startIcon={<LoginIcon />}
                  sx={{
                    marginLeft: "auto",
                    textTransform: "none",
                    fontWeight: "bold",
                    borderRadius: "30px",
                    padding: "8px 20px",
                    background: isDarkTheme
                      ? "linear-gradient(45deg, #0A1F44, #162B4D)"
                      : "linear-gradient(45deg, #0A1F44, #203A64)",
                    boxShadow: "0 4px 10px rgba(10, 31, 68, 0.3)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: isDarkTheme
                        ? "linear-gradient(45deg, #162B4D, #1E365A)"
                        : "linear-gradient(45deg, #203A64, #2A4980)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 6px 15px rgba(10, 31, 68, 0.4)",
                    },
                  }}
                >
                  User Login
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <AddLeadDialog
        open={openAddLead}
        onClose={() => setOpenAddLead(false)}
        onSuccess={() => setOpenAddLead(false)}
      />

      {/* Side Drawer Menu */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: 280, // Increased width of the drawer
            background: isDarkTheme 
              ? "linear-gradient(180deg, #0f172a 0%, #111827 100%)" 
              : "linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)",
            color: isDarkTheme ? "#fff" : "#000",
            borderRadius: "0 15px 15px 0",
            padding: "0",
            borderRight: isDarkTheme ? "1px solid rgba(148,163,184,0.25)" : "1px solid #dbe7f5",
            boxShadow: isDarkTheme
              ? "10px 0 24px rgba(2, 6, 23, 0.5)"
              : "10px 0 28px rgba(15, 23, 42, 0.14)",
            overflowY: "auto", // Ensure drawer content is scrollable
            display: "flex",
            flexDirection: "column",
            maxHeight: "100%", // Make sure drawer doesn't exceed viewport height
          },
        }}
        ModalProps={{
          keepMounted: true, // Better performance on mobile
        }}
        sx={{
          '& .MuiDrawer-paper': {
            top: 0, // Ensure drawer starts from the top
            height: '100%', // Full height
          },
          zIndex: 1300, // Ensure drawer appears above other elements
        }}
      >
        {/* User Profile Section - More refined and professional */}
        <Box sx={{ 
          padding: '12px 16px', 
          position: 'sticky',
          top: 0,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: isDarkTheme 
            ? "rgba(15, 23, 42, 0.95)" 
            : "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderBottom: isDarkTheme ? "1px solid rgba(148,163,184,0.2)" : "1px solid #e2e8f0",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          zIndex: 2,
        }}>
          <Avatar 
            sx={{ 
              width: 46, 
              height: 46, 
              bgcolor: isDarkTheme ? "#3949ab" : "#3f51b5",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              border: isDarkTheme ? "2px solid #90caf9" : "2px solid #fff",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            {userName?.charAt(0)?.toUpperCase() || "M"}
          </Avatar>
          
          <Box sx={{ ml: 1.5, flexGrow: 1, overflow: 'hidden' }}>
            <Typography 
              variant="subtitle1" 
              sx={{ 
                fontWeight: "600",
                lineHeight: 1.2,
                color: isDarkTheme ? "#fff" : "#000",
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {userName}
            </Typography>
            
            <Box 
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.8,
                mt: 0.5
              }}
            >
              <Box 
                sx={{
                  display: "inline-flex",
                  backgroundColor: isDarkTheme ? "rgba(25, 118, 210, 0.2)" : "rgba(25, 118, 210, 0.1)",
                  color: isDarkTheme ? "#90caf9" : "#1976d2",
                  fontWeight: "medium",
                  fontSize: "10px",
                  padding: "1px 6px",
                  borderRadius: "10px",
                  alignItems: "center",
                  height: "18px",
                  whiteSpace: 'nowrap'
                }}
              >
                ID: {userId}
              </Box>
              {/* <Typography 
                sx={{ 
                  fontSize: "10px", 
                  color: isDarkTheme ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.6)",
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {roleName}
              </Typography> */}
            </Box>
          </Box>
        </Box>

        {/* Divider Below the User Profile */}
        <Divider 
          sx={{ 
            backgroundColor: isDarkTheme ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.1)",
          }} 
        />

        {/* Menu Items - Scrollable content */}
        <Box sx={{
          flexGrow: 1,
          overflowY: "auto", // Allow scrolling of menu items
          pb: 2, // Add some padding at the bottom
        }}>
          <MenuList
            isDarkTheme={isDarkTheme}
            currentPath={location.pathname}
            handleMenuItemClick={handleMenuItemClick}
          />
        </Box>
      </Drawer>

      {/* Simplified Confirmation Dialog for Logout */}
      <Dialog
        open={openDialog}
        onClose={handleLogoutCancel}
        PaperProps={{
          sx: {
            padding: "24px",
            borderRadius: "16px",
            backgroundColor: isDarkTheme ? "#333" : "#fff",
            color: isDarkTheme ? "#fff" : "#000",
            boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.3)",
            maxWidth: "400px",
            width: "100%",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            fontWeight: "bold",
            fontSize: "22px",
            color: isDarkTheme ? "#ff5722" : "#d32f2f",
            pb: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: isDarkTheme 
                ? "rgba(244, 67, 54, 0.2)"
                : "rgba(244, 67, 54, 0.1)",
            }}
          >
            <LogoutIcon sx={{ fontSize: "28px" }} />
          </Box>
          Confirm Logout
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography
            variant="body1"
            sx={{
              fontSize: "16px",
              color: isDarkTheme ? "#ddd" : "#333",
              lineHeight: 1.6,
              textAlign: "center",
            }}
          >
            Are you sure you want to log out of the system?
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            gap: 2,
            padding: "20px 24px 8px",
          }}
        >
          <Button
            onClick={handleLogoutCancel}
            variant="outlined"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: "30px",
              padding: "8px 24px",
              borderColor: isDarkTheme ? "#888" : "#ccc",
              color: isDarkTheme ? "#fff" : "#000",
              minWidth: "120px",
              "&:hover": {
                borderColor: isDarkTheme ? "#fff" : "#888",
                backgroundColor: isDarkTheme ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setIsLoggingOut(true);
              // Use a default reason or empty string since we're not collecting it
              localStorage.clear();
              setTimeout(() => {
                setOpenDialog(false);
                setIsLoggingOut(false);
                navigate("/");
              }, 800); // Short delay for loading state to be visible
            }}
            variant="contained"
            color="error"
            disabled={isLoggingOut}
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              padding: "8px 24px",
              borderRadius: "30px",
              backgroundColor: isDarkTheme ? "#ff5722" : "#d32f2f",
              boxShadow: "0 4px 10px rgba(244, 67, 54, 0.3)",
              minWidth: "120px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor: isDarkTheme ? "#ff7043" : "#e57373",
                boxShadow: "0 6px 15px rgba(244, 67, 54, 0.4)",
              },
              transition: "all 0.3s ease",
            }}
          >
            {isLoggingOut && (
              <Box
                sx={{
                  display: "inline-block",
                  width: "16px",
                  height: "16px",
                  border: "2px solid rgba(255, 255, 255, 0.3)",
                  borderTop: "2px solid #fff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  marginRight: "8px",
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />
            )}
            {isLoggingOut ? "Logging out..." : "Logout"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ResponsiveAppBar;